module.exports = __webpack_public_path__ + "img/whiteBrandFrontPageImg02.e845985a.jpg";